<div class="investor-center-wrapper">
  <div class="container-fluid p-0">
    <div class="row g-0 align-items-center">
      <!-- Content Section -->
      <div class="col-12 col-lg-6 order-1 order-lg-1">
        <div class="content-box">
          <p class="mainTitle">مركز خدمات المستثمرين</p>
          <p class="subTitle">
            يقدم مركز خدمات المستثمرين العديد من الخدمات مثل التأسيس وعمليات الدمج
            والتصفية واعتماد وثائق المستثمرين وتسجيل الأصول غيرها من الخدمات.
          </p>
          <button class="btn btnGreen">إقرأ المزيد</button>
        </div>
      </div>
      
      <!-- Image Section -->
      <div class="col-12 col-lg-6 order-2 order-lg-2">
        <div class="image-container">
          <img src="../../../assets/infocenter.jpg" alt="مركز خدمات المستثمرين" class="investor-img" />
        </div>
      </div>
    </div>
  </div>
</div>